/**
 * Форматтеры для работы с клиентами
 */

import { formatTinKpp } from '@/entities/legal-entity/@x/client';

import { ClientType, getClientImportanceLabel } from '../model/constants';

/**
 * Форматирует важность клиента
 * @param value - значение важности
 * @returns отформатированное название
 */
export const formatClientImportance = (value: string): string => {
  return getClientImportanceLabel(value);
};

/**
 * Получает полное имя клиента
 * @param client - объект клиента
 * @returns полное имя клиента
 */
export const getClientFullName = (client: {
  type?: ClientType | null;
  legal_name?: string | null;
  first_name?: string | null;
  last_name?: string | null;
  patronymic_name?: string | null;
}): string => {
  if (client.type === ClientType.Company) return client.legal_name || 'Без названия';

  const parts = [client.first_name, client.patronymic_name, client.last_name].filter(Boolean);

  return parts.length > 0 ? parts.join(' ') : 'Без имени';
};

/** «ИНН 7707083893 · КПП 773601001»: только заданные части. */
export const formatClientRequisites = (client: { legal_tin?: string | null; legal_kpp?: string | null }): string =>
  formatTinKpp(client.legal_tin, client.legal_kpp);
